import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

//import images
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";
import logoSm from "../assets/images/logo-sm.png";

//import Components
import FullScreenDropdown from "../components/common/FullScreenDropdown";
import LanguageDropdown from "../components/common/LanguageDropdown";
import LightDark from "../components/common/LightDark";
import ProfileDropdown from "../components/common/ProfileDropdown";
import WhatsNewButton from "../components/common/WhatsNewButton";
import WhatsNewModal from "../components/common/WhatsNewModal";
import NewReleasesModal from "../components/common/NewReleasesModal";
import { checkPermissionByRoles } from "../helpers/utils";
import { ADMIN, COMUNICATIONS, GENERAL, ACCOUNTANT } from "../helpers/constants";
import { getPublishedReleaseNotes } from "../store/release-notes/actions";

const WHATS_NEW_LAST_SEEN_VERSION = "WHATS_NEW_LAST_SEEN_VERSION";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  const dispatch = useDispatch();

  // Full-list modal (button click)
  const [isWhatsNewOpen, setIsWhatsNewOpen] = useState(false);

  // Post-login modal (unseen releases only)
  const [isNewReleasesOpen, setIsNewReleasesOpen] = useState(false);
  const [unseenReleases, setUnseenReleases] = useState([]);

  // Badge dot
  const [hasUnseen, setHasUnseen] = useState(false);

  const showWhatsNew = checkPermissionByRoles([ADMIN, COMUNICATIONS, GENERAL, ACCOUNTANT]);

  // Check for unseen releases to show the badge dot
  const checkForNewReleases = useCallback(() => {
    if (!showWhatsNew) return;
    dispatch(getPublishedReleaseNotes())
      .then((data) => {
        if (data && Array.isArray(data) && data.length > 0) {
          const latestVersion = data[0]?.version;
          const lastSeen = localStorage.getItem(WHATS_NEW_LAST_SEEN_VERSION);
          if (latestVersion && latestVersion !== lastSeen) {
            setHasUnseen(true);
          }
        }
      })
      .catch(() => {});
  }, [dispatch, showWhatsNew]);

  useEffect(() => {
    checkForNewReleases();
  }, [checkForNewReleases]);

  // Auto-open new-releases modal once right after login
  useEffect(() => {
    const isPostLogin = sessionStorage.getItem("WHATS_NEW_CHECK_ON_LOGIN");
    if (!isPostLogin) return;
    sessionStorage.removeItem("WHATS_NEW_CHECK_ON_LOGIN");

    dispatch(getPublishedReleaseNotes())
      .then((data) => {
        if (data && Array.isArray(data) && data.length > 0) {
          const latestVersion = data[0]?.version;
          const lastSeen = localStorage.getItem(WHATS_NEW_LAST_SEEN_VERSION);
          if (latestVersion && latestVersion !== lastSeen) {
            // Filter to only unseen releases
            let unseen;
            if (!lastSeen) {
              // First-ever login — all releases are new
              unseen = data;
            } else {
              // Take everything newer than the last seen version
              unseen = [];
              for (const release of data) {
                if (release.version === lastSeen) break;
                unseen.push(release);
              }
            }

            if (unseen.length > 0) {
              setUnseenReleases(unseen);
              setHasUnseen(true);
              setIsNewReleasesOpen(true);
            }
          }
        }
      })
      .catch(() => {});
  }, [dispatch]);

  // Mark latest version as seen and clear badge
  const handleMarkAsSeen = () => {
    dispatch(getPublishedReleaseNotes())
      .then((data) => {
        if (data && Array.isArray(data) && data.length > 0) {
          const latestVersion = data[0]?.version;
          if (latestVersion) {
            localStorage.setItem(WHATS_NEW_LAST_SEEN_VERSION, latestVersion);
          }
        }
      })
      .catch(() => {});
    setHasUnseen(false);
  };

  // Close the post-login modal and mark as seen
  const handleNewReleasesClose = () => {
    setIsNewReleasesOpen(false);
    handleMarkAsSeen();
  };

  // Open the full-list modal from button click and mark as seen
  const handleWhatsNewButtonClick = () => {
    setIsWhatsNewOpen(true);
    handleMarkAsSeen();
  };

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;

    if (windowSize > 767) document.querySelector(".hamburger-icon").classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //For collapse vertical menu
    if (document.documentElement.getAttribute("data-layout") === "vertical") {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };
  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoDark} alt="" height="17" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="" height="17" />
                  </span>
                </Link>
              </div>

              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>

              {/* <SearchOption /> */}
            </div>

            <div className="d-flex align-items-center">
              {/* LanguageDropdown */}
              <LanguageDropdown />

              {/* WebAppsDropdown */}
              {/* <WebAppsDropdown /> */}

              {/* MyCartDropdwon */}
              {/* <MyCartDropdown /> */}

              {/* FullScreenDropdown */}
              <FullScreenDropdown />

              {/* WhatsNewButton — full list of all releases */}
              {showWhatsNew && (
                <WhatsNewButton
                  onClick={handleWhatsNewButtonClick}
                  hasUnseen={hasUnseen}
                />
              )}

              {/* Dark/Light Mode set */}
              <LightDark layoutMode={layoutModeType} onChangeLayoutMode={onChangeLayoutMode} />

              {/* NotificationDropdown */}
              {/* <NotificationDropdown /> */}

              {/* ProfileDropdown */}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>

      {/* Full release list modal — opened by button click */}
      {showWhatsNew && (
        <WhatsNewModal
          isOpen={isWhatsNewOpen}
          toggle={() => setIsWhatsNewOpen(!isWhatsNewOpen)}
        />
      )}

      {/* New releases modal — auto-opened after login, unseen only */}
      <NewReleasesModal
        isOpen={isNewReleasesOpen}
        toggle={handleNewReleasesClose}
        releases={unseenReleases}
      />
    </React.Fragment>
  );
};

export default Header;
